<template>
  <div ref='refImagePlaceholder' class="image__placeholder" :class="{ loaded, error, loading }"
    :style="placeholderStyle">
    <img
      v-if="!error"
      ref='refImage'
      class='image__item'
      :class="$props.class" 
      :style="imageStyle"
      :width="size.width"
      :height="size.height"
      @click="onImageClick">
    <div id='error' v-if="error" class="p-3 text-danger fw-normal text-decoration-none fst-normal">
      Ошибка загрузки файла
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      error: null,
      loading: true,
      loaded: null,
      containerWidth: null,
      naturalWidth: null,
      naturalHeight: null,
      resizeObserver: null
    }
  },
  mounted() {
    this.updateContainerWidth()
    this.observeContainerWidth()
    if (window.IntersectionObserver) {
      this.createObserver()
    } else {
      this.loadImage()
    }
  },
  beforeUnmount() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
      this.resizeObserver = null
    }
  },
  computed: {
    placeholderStyle() {
      return this.size.height ? { height: `${this.size.height}px` } : {}
    },
    imageStyle() {
      const style = {}
      if (this.size.width) {
        style.width = `${this.size.width}px`
      }
      if (this.size.height) {
        style.height = `${this.size.height}px`
      }
      return style
    },
    size: function () {
      const sourceWidth = Number(this.width || this.naturalWidth)
      const sourceHeight = Number(this.height || this.naturalHeight)

      if (!sourceHeight || !sourceWidth) {
        return { width: this.width, height: this.height }
      }

      const ratio = sourceWidth / sourceHeight

      let nextWidth
      if (this.targetHeight) {
        let nextHeight = this.maxHeight ? Math.min(this.targetHeight, this.maxHeight) : this.targetHeight
        nextWidth = nextHeight * ratio
        if (this.containerWidth && nextWidth > this.containerWidth) {
          nextWidth = this.containerWidth
          nextHeight = nextWidth / ratio
        }
        return { width: nextWidth, height: nextHeight }
      }

      if (this.maxHeight) {
        nextWidth = Math.min(2.5 * sourceWidth, this.containerWidth || sourceWidth)
      } else if (ratio < 1) {
        nextWidth = Math.min(2.5 * sourceHeight, this.containerWidth || sourceWidth) * 1.2 * ratio
      } else {
        nextWidth = Math.min(2.5 * sourceWidth, this.containerWidth || sourceWidth)
      }

      let nextHeight = nextWidth / ratio
      if (this.maxHeight && nextHeight > this.maxHeight) {
        nextHeight = this.maxHeight
        nextWidth = nextHeight * ratio
      }
      return { width: nextWidth, height: nextHeight }
    }
  },
  methods: {
    updateContainerWidth() {
      this.containerWidth = this.$refs.refImagePlaceholder?.offsetWidth || null
    },
    observeContainerWidth() {
      if (!window.ResizeObserver || !this.$refs.refImagePlaceholder) {
        return
      }

      this.resizeObserver = new ResizeObserver(() => this.updateContainerWidth())
      this.resizeObserver.observe(this.$refs.refImagePlaceholder)
    },
    loadImage() {
      const imageElement = this.$refs.refImage
      if (imageElement) {
        this.loading = true
        imageElement.addEventListener('load', () => {
          this.naturalWidth = imageElement.naturalWidth
          this.naturalHeight = imageElement.naturalHeight
          this.loaded = true
          this.loading = false
          this.error = false
          this.$emit('imageLoaded', {
            naturalWidth: this.naturalWidth,
            naturalHeight: this.naturalHeight,
            width: this.size.width,
            height: this.size.height,
          })
        })
        imageElement.addEventListener('error', () => {
          this.loaded = false
          this.loading = false
          this.error = true
        })

        imageElement.src = this.$props.src
      }
    },

    handleIntersect(entries, observer) {
      const el = this.$refs.refImagePlaceholder
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.loadImage()
          observer.unobserve(el)
        }
      })
    },

    createObserver() {
      const el = this.$refs.refImagePlaceholder
      const options = {
        root: null,
        threshold: '0',
        rootMargin: '200px',
      };
      const observer = new IntersectionObserver(this.handleIntersect, options);
      observer.observe(el);
    },

    onImageClick(event) {
      this.$emit('imageClicked', event)
    }
  },
  props: {
    width: Number,
    height: Number,
    maxHeight: Number,
    targetHeight: Number,
    class: String,
    src: {
      type: String,
      required: true
    },
  }
}

</script>
<style>
.image__placeholder img {
  height: auto;
  max-width: 100%;
}

.image__placeholder.loading {
  background-color: #eee;
}

.image__placeholder #error {
  display: none
}

.image__placeholder.error {
  background-color: #fee;
}

.image__placeholder.error #error {
  display: block;
}
</style>
